if($('.longevity-table').length > 0) {
    const lgTableWrapper = $('.longevity-table #tableContainer');
    const lgTable = $('.longevity-table .table');
    const lgTableBody = $('.longevity-table #dynamicTableBody');
    const lgSearchInput = $('.longevity-table .search-input');
    const resetButton = $('.longevity-table .lg-reset');
    const searchButton = $('.longevity-table .lg-search');
    const noResultsText = $('.longevity-table .lg-no-results');

    resetButton.on('click', function(e) {
        e.preventDefault();
        lgSearchInput.val('');
        getLongevityData();
    })

    searchButton.on('click', function(e) {
        e.preventDefault();
        lgSearchInput.val(normalizeInput(lgSearchInput.val(), false));

        if(lgSearchInput.val() !== '') {
            getLongevityData({'q': normalizeInput(lgSearchInput.val(), true)});
        }
    })

    lgSearchInput.on('keyup', function(e) {
        if (e.which === 13 && lgSearchInput.val() !== '') {
            searchButton.click();
        }
    })

    lgSearchInput.on('blur', function (e) {
        lgSearchInput.val(normalizeInput(lgSearchInput.val(), false));
    })

    const formatResponse = (data, fallback) => {
        return data ? data : fallback
    }

    const getLongevityData = function(attrs) {
        lgTableBody.empty();
        $.ajax({
            url: `${window.location.origin + ctxPath}/.rest/product/v1/longevity`,
            method: 'GET',
            dataType: 'json',
            data: attrs,
            headers: {
                'Accept': 'application/json'
            },
            timeout: 10000
        })
        .done(function (data, textStatus, xhr) {
            if(xhr.status === 204) {
                noResultsText.show();
                lgTableWrapper.hide();
                $.tablesorter.destroy(lgTable, false);
            }

            if (data && 'items' in data && data.items.length > 0) {
                lgTableWrapper.show();
                noResultsText.hide();
                $.tablesorter.destroy(lgTable, false);

                data.items.forEach(function (item) {
                    const tr = `<tr>
                    <td><a href="/pip/${item.productCode}">${item.productCode}</a></td>
                    <td>${formatResponse(item.launchDate, '-')}</td>
                    <td>${formatResponse(item.longevityDate, '-')}</td>
                    <td>${formatResponse(item.longevityDuration, '-')}</td>
                    </tr>`;
                    lgTableBody.append(tr);
                })

                $('.longevity-table table.tablesorter').tablesorter();
            }
        })
        .fail(function (xhr, textStatus, errorThrown) {
            console.error('ERROR', xhr.status, xhr.responseText || errorThrown);
        });
    };

    $('[data-toggle="tooltip"]').tooltip({container: 'body', html: false, trigger: 'hover'});

    const attrs = [{name: 'q', value: ''}];
    getLongevityData(attrs);
}